<!-- Home Page -->
<div class="container-fluid">

    <!-- Fullscreen Slideshow Section -->
    <section id="hero" class="hero-section d-flex justify-content-center align-items-center">
      <div class="text-center text-black card shadow-sm border-0 rounded-4 p-4">
        <h1>Living Made Simple</h1>
        <p>One hub for managing your rental — or finding your next one.</p>
        <a href="/apply" class="btn btn-primary">Get Started</a>
      </div>
    </section>




    <!-- Fullscreen Section with Image on Left and Text on Right (Second Section) -->
    <section class="row full-screen-section">
      <div class="col-lg-6 d-none d-lg-block h-100" >
        <img src="../../../assets/images/home1.jpg" alt="Home" class="img-fluid w-100">
      </div>
      <div class="col-lg-6 text-section">
        <h2>Find Your Next Home</h2>
        <p>Explore available properties, schedule viewings, and apply — all from one place. CLRentals makes finding your next home effortless.</p>
        <button class="btn btn-primary" (click)="goToApply()">Browse Listings</button>
      </div>
    </section>

    <!-- Fullscreen Section with Image on Right and Text on Left (Third Section) -->
    <section class="row full-screen-section">
      <div class="col-lg-6 order-lg-2 h-100">
        <img src="../../../assets/images/home2.jpg" alt="Home" class="img-fluid w-100">
      </div>
      <div class="col-lg-6 text-section">
        <h2>Already Renting with Us?</h2>
        <p>Access your dashboard to pay rent, submit maintenance requests, and stay up to date — all in one place.</p>
        <button class="btn btn-dark" (click)="goToPortal()">Log In to Your Account</button>
      </div>
    </section>
    <script>
        // Simple JavaScript to change background images every few seconds
        let currentIndex = 0;
        const images = [
          '../../../assets/images/slideshow1.png',
        ];

        setInterval(() => {
          currentIndex = (currentIndex + 1) % images.length;
          document.querySelector('.hero-section').style.backgroundImage = `url('${images[currentIndex]}')`;
        }, 5000); // Change image every 5 seconds
        // Change navbar style on scroll
        window.addEventListener('scroll', function() {
          const navbar = document.querySelector('.navbar');
          if (window.scrollY > 50) {
            navbar.classList.add('scrolled');
          } else {
            navbar.classList.remove('scrolled');
          }
        });
              </script>

  </div>
